export default "__VITE_ASSET__h9V8rpWI__"